import http from '@/utils/http';

import type { IBaseResponse } from '@intelligence/types/common';

// 查询字段搜索结果
export const getOptions = (type: string): IBaseResponse<any> => {
  return http({
    url: '/api/v1/intelligence_pc/filterListRegionCountry',
    method: 'post',
    data: {
      type: [
        {
          tabName: type || 'pc',
        },
      ],
    },
    rawData: true,
  }) as IBaseResponse<any>;
};
